var LangArray = {
	//简体中文
	'zh-cn': {
		dollarSign: '￥',
		dollarSignCn: '元'
	},

	//欧洲英文
	'europe': {
		dollarSign: '€',
		dollarSignCn: '欧元'
	},

	//美/英
	'en': {
		dollarSign: '$',
		dollarSignCn: '美元'
	},

	//港元
	'HKD': {
		dollarSign: 'HKD',
		dollarSignCn: '港元'
	},

	//卢布
	'RUB': {
		dollarSign: '₽',
		dollarSignCn: '卢布'
	},

	//马来西亚林吉特
	'RM': {
		dollarSign: 'RM',
		dollarSignCn: '马来西亚林吉特'
	},

	//菲律宾比索
	'PHP': {
		dollarSign: '₱',
		dollarSignCn: '菲律宾比索'
	},

	//泰铢
	'THB': {
		dollarSign: '฿',
		dollarSignCn: '泰铢'
	},

	//加拿大币
	'CAD': {
		dollarSign: '$',
		dollarSignCn: '加币'
	},

	//新加坡币
	'SGD': {
		dollarSign: '$',
		dollarSignCn: '新币'
	},

	//老挝
	'kip': {
		dollarSign: 'kip',
		dollarSignCn: '基普'
	},
};
export default LangArray;


// WEBPACK FOOTER //
// ./src/config/Lang.js